import { useState, useCallback, useMemo } from "react";
import usePageTitle from "../../hooks/usePageTitle";
import { DashboardNavigationBar } from "../../components/navbars/DashboardNavigationBar";
import { InboxSidebar } from "../../components/inbox/InboxSidebar";
import { EmailList } from "../../components/inbox/EmailList";
import { InboxWorkflowPanel } from "../../components/inbox/InboxWorkflowPanel";
import { FOLDERS, EMAILS, WORKFLOWS } from "../../data/inboxMockData";

export default function InboxPage() {
  usePageTitle("Inbox");
  const [activeFolder, setActiveFolder] = useState("inbox");
  const [selectedEmailId, setSelectedEmailId] = useState(null);

  // Filter emails by active folder
  const folderEmails = useMemo(
    () => EMAILS.filter((e) => e.folder === activeFolder),
    [activeFolder],
  );

  // Get selected email
  const selectedEmail = useMemo(
    () => EMAILS.find((e) => e.id === selectedEmailId),
    [selectedEmailId],
  );

  // Get workflow for selected email
  const selectedWorkflow = useMemo(
    () => (selectedEmail ? WORKFLOWS[selectedEmail.workflowId] : null),
    [selectedEmail],
  );

  const handleSelectFolder = useCallback((folderId) => {
    setActiveFolder(folderId);
    setSelectedEmailId(null);
  }, []);

  const handleSelectEmail = useCallback((email) => {
    setSelectedEmailId(email.id);
  }, []);

  return (
    <>
      <DashboardNavigationBar />
      <div className="max-w-7xl mx-auto px-4">
        <div
          className="flex bg-white rounded-xl border border-slate-200 overflow-hidden mt-4"
          style={{ height: "calc(100vh - 120px)" }}
        >
          {/* Left: Folder sidebar */}
          <InboxSidebar
            folders={FOLDERS}
            activeFolder={activeFolder}
            onSelectFolder={handleSelectFolder}
          />

          {/* Middle: Email list */}
          <div className="w-80 flex-shrink-0">
            <EmailList
              emails={folderEmails}
              selectedEmailId={selectedEmailId}
              onSelectEmail={handleSelectEmail}
            />
          </div>

          {/* Right: Workflow panel */}
          <div className="flex-1 p-3">
            <InboxWorkflowPanel
              nodes={selectedWorkflow?.nodes || []}
              edges={selectedWorkflow?.edges || []}
              workflowTitle={selectedWorkflow?.title || ""}
              emailId={selectedEmailId}
            />
          </div>
        </div>
      </div>
    </>
  );
}
